
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chapterId]/reflections",
      function () {
        return require("private-next-pages/[chapterId]/reflections.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[chapterId]/reflections"])
      });
    }
  